import {appConstants} from '../_constants';
import {initialState} from "../_store";

export function viewData(state=initialState.viewData, action) {
  switch (action.type) {
    case appConstants.VIEW_DATA:
      return action.obj;
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/view-data.reducer.js